interface Props {
  onInstall: () => void
  onDismiss: () => void
}

export default function InstallBanner({ onInstall, onDismiss }: Props) {
  return (
    <div className="bg-[#2563eb] dark:bg-[#1d4ed8] text-white px-4 py-2 flex items-center gap-3">
      <span className="flex-1 text-sm font-medium">
        Add Whistle to your home screen for offline access
      </span>
      <button
        onClick={onInstall}
        className="shrink-0 bg-white dark:bg-[#1e293b] text-[#2563eb] px-3 py-1 rounded-lg font-semibold text-xs"
      >
        Install
      </button>
      <button
        onClick={onDismiss}
        aria-label="Dismiss install prompt"
        className="shrink-0 opacity-70 hover:opacity-100 text-xl leading-none"
      >
        ✕
      </button>
    </div>
  )
}
